export default function({ dispatch, commit }, credentials) {
    commit('startedAuthentication')

    // POST /auth/login
    return dispatch('post', {
        url: '/provider/auth/login',
        data: credentials
    }, {
        root: true
    })
    .then((token) => {
        try {
            commit('finishedAuthentication')
            commit('receivedToken', token)
            if(token.payload.mfa)
                return {
                    mfa: true,
                    mfa_email: token.mfa_email ? token.mfa_email.replaceAll('*', 'x') : null,
                    mfa_phone: token.mfa_phone ? token.mfa_phone.replaceAll('*', 'x') : null,
                    is_email_mfa: credentials.mfa && (credentials.mfa === 'email' || !token.mfa_phone)
                }
            if(token.payload.cp)
                return {
                    changePassword: true
                }
            return dispatch('user/getUser', {}, { root: true })
            .then(() => {
                return dispatch('ws/connect', {}, { root: true })
            })
            .then(() => {
                return token
            })
            .catch((error) => {
                throw { code: 'ApiError' }
            })
        } catch (error) {
            throw {
                code: 'ApiError'
            }
        }
        
    })
    .catch((error) => {
        commit('finishedAuthentication')
        throw error
    })
}
